export default function Menu({ route, image, text }) {
    return (
        <div
            className="relative h-40 w-80 bg-gray-900 hover:cursor-pointer overflow-hidden shadow-2xl rounded-md"
            style={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            onClick={() => {
                // Navigate to the selected menu URL.
                window.location.href = route;
            }}
        >
            <div className="absolute w-full h-full bg-black bg-opacity-20"></div>
            {/* Centered white stripe with cut-out text */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative bg-white bg-opacity-90 w-full text-center px-4 py-2">
                    <p
                        className="font-bold text-transparent text-xl"
                        style={{
                            backgroundImage: `url(${image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            mixBlendMode: "multiply",
                        }}
                    >
                        {text}
                    </p>
                </div>
            </div>
        </div>
    );
}
